import { useId } from "react";

export function QuestionInput({
  value,
  onChange,
  maxLength,
  disabled,
}: {
  value: string;
  onChange: (v: string) => void;
  maxLength: number;
  disabled?: boolean;
}) {
  const id = useId();
  const over = value.length > maxLength;

  return (
    <div className="field">
      <label htmlFor={id}>Question to deliberate</label>
      <textarea
        id={id}
        value={value}
        placeholder="State the question, decision, or problem you want the models to deliberate on…"
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={4}
        aria-describedby={`${id}-hint`}
        data-testid="question-input"
      />
      <div
        id={`${id}-hint`}
        className="row"
        style={{ justifyContent: "space-between", fontSize: 11 }}
      >
        <span className="muted">
          Be as specific as helpful. Shift + Enter for new lines.
        </span>
        <span
          style={{
            color: over ? "var(--negative)" : "var(--text-dim)",
            fontSize: 13,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {value.length} / {maxLength}
        </span>
      </div>
    </div>
  );
}
